var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFlagPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#151A30",
    d: "M15.9 9.4a6.501 6.501 0 010 13 6.501 6.501 0 010-13zM5.083 3.002c1.017.04 1.85.842 1.913 1.842.015.226-.01.451-.074.668l-.054.16.28-.095a7.062 7.062 0 012.15-.327c2.406 0 3.987 1.223 5.9 1.223 1.447 0 2.951-.56 4.178-1.12.721-.33 1.542.148 1.618.905l.006.115.001 3.236A8.102 8.102 0 007.81 16.307c-.53.116-.997.265-1.419.43l-.248.1v3.32c0 .43-.327.784-.75.836L5.286 21h-.572a.852.852 0 01-.85-.738l-.007-.106V6.584A1.96 1.96 0 013 4.969c0-1.018.784-1.855 1.79-1.958L4.936 3h.147zM16.45 11.97h-1.1a.558.558 0 00-.55.563v2.25h-2.2a.557.557 0 00-.55.562v1.125c0 .31.247.563.55.563h2.2v2.25c0 .309.247.562.55.562h1.1c.303 0 .55-.253.55-.563v-2.25h2.2c.303 0 .55-.253.55-.562v-1.125a.558.558 0 00-.55-.563H17v-2.25a.557.557 0 00-.55-.562z"
  }))));
}

export default SvgFlagPlus;